import { useEffect, useState } from 'react';
import { useApiClient } from 'src/hooks/useApiClient';
import { stringToOption } from 'src/utils';
import type { SelectOptions } from './vehicleForm';

export const useDealerOptions = (): SelectOptions[] => {
	const { apiClient, handleApi } = useApiClient();
	const [dealerOptions, setDealerOptions] = useState<SelectOptions[]>([]);

	useEffect(() => {
		handleApi(apiClient.dealerController.getRegisterDealers())
			.then((res: any[]) =>
				setDealerOptions(res.map((r) => stringToOption(r.ragione_sociale)))
			)
			.catch(() => {});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return dealerOptions;
};
